import React from 'react';
import '../../styles/product-card.css';

const ProductCard = ({ product, onClick }) => {
  const isLowStock = product.current_stock <= product.min_stock_level;
  const isOutOfStock = product.current_stock === 0;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', {
      style: 'currency',
      currency: 'KES'
    }).format(amount);
  };

  return (
    <div 
      className={`product-card ${isOutOfStock ? 'out-of-stock' : ''}`}
      onClick={!isOutOfStock ? onClick : undefined}
    >
      {product.image_url ? (
        <img src={product.image_url} alt={product.product_name} className="product-image" />
      ) : (
        <div className="product-image-placeholder">
          <span>📦</span>
        </div>
      )}

      <div className="product-info">
        <h4 className="product-name">{product.product_name}</h4>
        {product.sku && <div className="product-sku">SKU: {product.sku}</div>}
        
        <div className="product-price-row">
          <span className="product-price">{formatCurrency(product.selling_price)}</span>
          {product.wholesale_price && (
            <span className="product-wholesale">
              Wholesale: {formatCurrency(product.wholesale_price)}
            </span>
          )}
        </div>

        <div className="product-stock">
          <span className={`stock-badge ${isLowStock ? 'low' : 'normal'}`}>
            Stock: {product.current_stock} {product.unit}
          </span>
          {isLowStock && !isOutOfStock && (
            <span className="low-stock-warning">⚠️ Low Stock</span>
          )}
          {isOutOfStock && (
            <span className="out-of-stock-label">Out of Stock</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductCard;